export const getPostWord = (str: string, firstVal: string, secondVal: string) => {
    let val = firstVal;
    try {
        let lastStr = str[str.length - 1].charCodeAt(0);
        // 한글의 제일 처음과 끝의 범위밖일 경우는 오류
        if (lastStr < 0xac00 || lastStr > 0xd7a3) {
            return secondVal;
        }
        let lastCharIndex = (lastStr - 0xac00) % 28;
        // 종성인덱스가 0이상일 경우는 받침이 있는경우이며 그렇지 않은경우는 받침이 없는 경우
        if (lastCharIndex > 0) {
            // 받침이 있는경우
            // 조사가 '로'인경우 'ㄹ'받침으로 끝나는 경우는 '로' 나머지 경우는 '으로'
            if (firstVal === "으로" && lastCharIndex === 8) val = secondVal;
            else val = firstVal
        } else {
            // 받침이 없는 경우
            val = secondVal;
        }
    } catch (e) {
        return val;
    }

    return val;
};

export const resizedSRC = (src: string, [width, height]: [number, number]) => {
    const IMAGE_URL = "HITIT_IMAGE_URL";
    let __src__ = src;
    if (src.indexOf(IMAGE_URL) !== -1) {

        //autojpg필터는 fit-in필터로 exif가 특정 브라우저에서 회전하는 것을 막는 조치이다. 
        const resizeSpec = `fit-in/${width}x${height}/filters:strip_exif()/`;
        const imageLocation = src.replace(IMAGE_URL, "");

        const URL = IMAGE_URL + resizeSpec + imageLocation;
        __src__ = URL
    }

    return __src__
}